import React from 'react';

const paddingClasses = {
    none: '',
    sm: 'p-3',
    base: 'p-4',
    md: 'p-6',
};

export const Card = ({
    children,
    className = '',
    title,
    action,
    padding = 'md',
    headerClassName = '',
    titleClassName = '',
    ...props
}) => {
    const bodyPadding = paddingClasses[padding] ?? paddingClasses.md;

    return (
        <div
            className={`bg-white rounded-lg shadow-sm border border-gray-200 ${className}`}
            {...props}
        >
            {title && (
                <div
                    className={`px-6 py-4 border-b border-gray-200 flex justify-between items-center gap-3 ${headerClassName}`}
                >
                    <h3
                        className={
                            titleClassName?.trim()
                                ? titleClassName
                                : 'text-lg font-semibold text-gray-900'
                        }
                    >
                        {title}
                    </h3>
                    {action && <div className="shrink-0">{action}</div>}
                </div>
            )}
            {bodyPadding ? (
                <div className={bodyPadding}>{children}</div>
            ) : (
                children
            )}
        </div>
    );
};
